import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import WidgetContainer from 'components/Apps/WidgetContainer'
import messages from '../translate'
import SLSitesInfoTable from '../InfoTable/SLSitesInfoTable'

function AllSitesList(props) {
  const {
    intl: { formatMessage },
  } = props

  return (
    <WidgetContainer
      className="site-list"
      name={`${formatMessage(messages.allSites)} - ${formatMessage(
        messages.siteList,
      )}`}>
      <SLSitesInfoTable />
    </WidgetContainer>
  )
}

export default connect(state => ({
  sitesData: state.getIn(['seaLice', 'sitesData']),
  licenseeId: state.getIn(['profile', 'licenseeId']),
}))(injectIntl(AllSitesList))
